import React from 'react';

import {
  AppBar,
  Toolbar,
  Typography,
} from '@mui/material';

/** プロパティ */
export type Props = {
  /** タイトル */
  title: string,
}

const DialogTitle: React.FC<Props> = ({ title }) => (
  <AppBar sx={{ position: 'relative' }}>
    <Toolbar>
      <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
        {title}
      </Typography>
    </Toolbar>
  </AppBar>
);

export default DialogTitle;
